import { LocalStorageKeys } from '@constants/enums';
import GlobalLoader from '@efex-components/common/GlobalLoader/GlobalLoader';
import { selectProfileData } from '@pages/profile/store/selectors';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AuthInitializer from '@/modules/auth/AuthInitializer';
import LoadError from '../LoadError/LoadError';
// import RequestPaymentFeature from './RequestPaymentFeature/RequestPaymentFeature';

const ErrorComponent = () => <LoadError />;

const PaymentLinkMfe = () => {
  const ACCESS_TOKEN = localStorage.getItem(LocalStorageKeys.TOKEN);
  const userProfile = useSelector(selectProfileData);

  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const language = i18n.language as 'en' | 'es';

  const handleOnClose = () => {
    navigate('/dashboard');
  };

  if (!userProfile?.company.isActivePaymentLink) {
    navigate('/dashboard');
    // return <RequestPaymentFeature onClose={handleOnClose} />;
  }

  const PaymentLink = lazy(() => {
    if (!ACCESS_TOKEN) {
      return Promise.resolve({ default: ErrorComponent });
    }
    return import('paymentLink/App').catch((error) => {
      console.error(error);
      return { default: ErrorComponent };
    });
  });

  return (
    <AuthInitializer>
      <Suspense fallback={<GlobalLoader />}>
        <PaymentLink
          token={ACCESS_TOKEN || ''}
          language={language}
          onClose={handleOnClose}
        />
      </Suspense>
    </AuthInitializer>
  );
};

export default PaymentLinkMfe;
